import React from 'react'

window.addEventListener("scroll", () => {
  const number = document.getElementsByClassName('number');
  console.log(number);
  let i;
  for(i=0; i<number.length;i++){
      const con_Position = number[i].getBoundingClientRect().top;
      const scr_position = window.innerHeight;
      if(con_Position < scr_position){
          const speed = 1000;
          for(let i= 0; i<number.length;i++){
              incNumber(number[i]);
          }

          function incNumber(elem) {
              let text = +elem.innerText;
              const value = +elem.getAttribute("data-target")
              const inc = value / speed;
              if (text < value) {
                  elem.innerText = Math.ceil(inc + text);
                  setTimeout(() => {
                      incNumber(elem);
                  }, 1);
              } else {
                  elem.innerText = Math.ceil(value);
              }
          }
      }
  }


})
const whychoose=[
  {
    id:1,
    img:`./Assets/icons/idea.png`,
    heading:`Projects Completed`,
  },
  {
    id:2,
    img:`./Assets/icons/smiley.png`,
    heading:`Happy Customers`,
  },
  {
    id:3,
    img:`./Assets/icons/idea.png`,
    heading:`Projects Completed`,
  },
]

export const WhyChooseUs = () => {
  return (
    <section className="whyschoous p-top p-btm">
    <div className="container">
        <div className="contant">
        <span className='title'>Why Choose Techsaga</span>
        <h2>We are an award  wining company</h2>
        <p>Dedication and devotion turned into in no way on leave out for the duration of our adventure as we are assured approximately the brilliant consequences. enthusiasm  our customers.</p>
        <div className="flex spce-btwn align-center">
            {
             whychoose.map((relEl)=>{
                return(
                  <div className="box" key={relEl.id}>
                  <div className="icon">
                      <img src={relEl.img} alt="projects" />

                  </div>
                  <div className="num">
                     <span><span className="number" data-target="920">0</span> +</span>
                     <h4>{relEl.heading}</h4>
                  </div>
              </div>
                )
              })
            }
        </div>
        </div>
    </div>

    </section>
  )
}
